import angular from 'angular';
import buttonTemplate from './rw-clear-field.html';

/**
 * This directive adds button which clears input field it's attached to. Button becomes visible only when ngModel
 * has non-empty view value.
 *
 * Usage:
 * <input ng-model="$ctrl.myField" rw-clear-field="$ctrl.clearMyField()">
 */
export default function rwClearFieldDirective($compile) {
  return {
    require: ['rwClearField', 'ngModel'],
    controller: angular.noop,
    controllerAs: 'rwClearField',
    bindToController: {
      onClear: '&rwClearField',
    },
    link: (scope, element, attrs, [ctrl, ngModel]) => {
      ctrl.ngModel = ngModel;
      const button = $compile(buttonTemplate)(scope);
      element.after(button);
      element.addClass('has-rw-clear-field');
    },
  };
}

rwClearFieldDirective.$inject = ['$compile'];



// WEBPACK FOOTER //
// ./src/modules/utils/rw-clear-field/rw-clear-field-directive.js